import { render, staticRenderFns } from "./Playlists.vue?vue&type=template&id=1bb735d9"
import script from "./Playlists.vue?vue&type=script&lang=ts"
export * from "./Playlists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports